import useStore from "../store"
import { Outlet } from "react-router-dom"
import MessageHandling from "./MessageHandling/MessageHandling"
import Login from "./Login"
import NavBar from "./NavBar/NavBar"
import { ErrorBoundary } from "@rollbar/react"
import ErrorDisplay from "./ErrorDisplay"
import { useForceReload } from "../hooks/useForceReload"

export default function Root() {
  const user = useStore((state) => state.user)

  // Forces a reload between pages if the app has been open for a very long time
  useForceReload()

  return(
    <ErrorBoundary fallbackUI={ErrorDisplay}>
      <MessageHandling>
        <NavBar>
          {user ? <Outlet /> : <Login />}
        </NavBar>
      </MessageHandling>
    </ErrorBoundary>
  )
}